module.exports = __webpack_public_path__ + "img/backyard-bushes-by-water.6c25a9ce.webp";